module.exports = __webpack_public_path__ + "img/filter.176c5b92.svg";